document.addEventListener("DOMContentLoaded", function () {

  const applyBadge = () => {
    document.querySelectorAll(".jm-review-item, .jdgm-rev").forEach(review => {

      // 找到名字节点
      const nameBlock =
        review.querySelector(".jm-reviewer-info__name") ||
        review.querySelector(".jdgm-rev__author");

      if (!nameBlock) return;

      // 已经插入过自定义徽章就跳过
      if (nameBlock.querySelector(".jw-custom-badge")) return;

      // 判断 Judge.me 是否标记为 Verified Buyer（两种结构）
      const judgeVerified =
        review.querySelector(".jdgm-rev__buyer-badge.jdgm--verified") ||
        review.querySelector(".jm-reviewer-badge--verified");

      // 如果 Judge.me 自带 Verified → 删除原徽章 → 插入你自己的格式
      if (judgeVerified) {
        judgeVerified.remove();

        const badge = document.createElement("span");
        badge.className = "jw-custom-badge";
        badge.textContent = "Verified";
        nameBlock.appendChild(badge);
      } else {
        const badge = document.createElement("span");
        badge.className = "jw-custom-badge";
        badge.textContent = "Reviewer"; // ⭐ 安全中性标签
        nameBlock.appendChild(badge);
      }

    });
  };

  // 初次执行
  applyBadge();

  // 监听 Judge.me 动态加载
  new MutationObserver(applyBadge).observe(document.body, {
    childList: true,
    subtree: true
  });

});


(function () {
  let isModifying = false;

  /*******************************
   * 1. 黄金勋章 (Gold Medal)
   *******************************/
  const JW_MEDAL_1 = `
  <svg viewBox="0 0 120 120" xmlns="http://www.w3.org/2000/svg">
    <defs>
      <linearGradient id="jwGoldGrad" x1="0%" y1="0%" x2="100%" y2="100%">
        <stop offset="0%" stop-color="#FFE259" />
        <stop offset="30%" stop-color="#FFA751" />
        <stop offset="70%" stop-color="#FFD700" />
        <stop offset="100%" stop-color="#B8860B" />
      </linearGradient>
      <linearGradient id="jwRedGrad" x1="0%" y1="0%" x2="0%" y2="100%">
        <stop offset="0%" stop-color="#FF416C" />
        <stop offset="100%" stop-color="#FF4B2B" />
      </linearGradient>
      <filter id="jwShadow" x="-10%" y="-10%" width="130%" height="130%">
        <feDropShadow dx="0" dy="4" stdDeviation="4" flood-opacity="0.3"/>
      </filter>
    </defs>
    <g filter="url(#jwShadow)">
      <path d="M40 50 L25 110 L45 100 L60 75 Z" fill="url(#jwRedGrad)" />
      <path d="M80 50 L95 110 L75 100 L60 75 Z" fill="url(#jwRedGrad)" />
    </g>
    <circle cx="60" cy="55" r="42" fill="url(#jwGoldGrad)" filter="url(#jwShadow)" />
    <circle cx="60" cy="55" r="36" fill="none" stroke="#FFFFFF" stroke-width="2" stroke-opacity="0.6" stroke-dasharray="6,4" />
    <circle cx="60" cy="55" r="32" fill="none" stroke="#B8860B" stroke-width="1.5" stroke-opacity="0.4" />
    <path d="M38 55 Q36 45 42 38 Q44 44 42 52 Z" fill="#FFFFFF" fill-opacity="0.4" />
    <path d="M35 63 Q34 53 40 46 Q42 52 40 60 Z" fill="#FFFFFF" fill-opacity="0.4" />
    <path d="M82 55 Q84 45 78 38 Q76 44 78 52 Z" fill="#FFFFFF" fill-opacity="0.4" />
    <path d="M85 63 Q86 53 80 46 Q78 52 80 60 Z" fill="#FFFFFF" fill-opacity="0.4" />
    <polygon points="60,30 68,46 86,48 73,61 77,79 60,70 43,79 47,61 34,48 52,46" fill="#FFFFFF" filter="url(#jwShadow)" />
    <polygon points="60,35 65,47 78,49 68,59 71,72 60,65 49,72 52,59 42,49 55,47" fill="url(#jwGoldGrad)" />
  </svg>
  `;

  /*******************************
   * 2. 白银勋章 (Silver Medal)
   *******************************/
  const JW_MEDAL_2 = `
  <svg viewBox="0 0 120 120" xmlns="http://www.w3.org/2000/svg">
    <defs>
      <linearGradient id="jwSilverGrad" x1="0%" y1="0%" x2="100%" y2="100%">
        <stop offset="0%" stop-color="#FFFFFF" />
        <stop offset="25%" stop-color="#E0E0E0" />
        <stop offset="50%" stop-color="#B5B5B5" />
        <stop offset="75%" stop-color="#D9D9D9" />
        <stop offset="100%" stop-color="#8E8E8E" />
      </linearGradient>
      <linearGradient id="jwBlueGrad" x1="0%" y1="0%" x2="0%" y2="100%">
        <stop offset="0%" stop-color="#4FACFE" />
        <stop offset="100%" stop-color="#00F2FE" />
      </linearGradient>
      <filter id="jwShadow2" x="-10%" y="-10%" width="130%" height="130%">
        <feDropShadow dx="0" dy="4" stdDeviation="4" flood-opacity="0.25"/>
      </filter>
    </defs>
    <g filter="url(#jwShadow2)">
      <path d="M40 50 L25 110 L45 100 L60 75 Z" fill="url(#jwBlueGrad)" />
      <path d="M80 50 L95 110 L75 100 L60 75 Z" fill="url(#jwBlueGrad)" />
    </g>
    <circle cx="60" cy="55" r="42" fill="url(#jwSilverGrad)" filter="url(#jwShadow2)" />
    <circle cx="60" cy="55" r="36" fill="none" stroke="#FFFFFF" stroke-width="2" stroke-opacity="0.7" stroke-dasharray="6,4" />
    <circle cx="60" cy="55" r="32" fill="none" stroke="#7E7E7E" stroke-width="1.5" stroke-opacity="0.3" />
    <path d="M38 55 Q36 45 42 38 Q44 44 42 52 Z" fill="#FFFFFF" fill-opacity="0.5" />
    <path d="M35 63 Q34 53 40 46 Q42 52 40 60 Z" fill="#FFFFFF" fill-opacity="0.5" />
    <path d="M82 55 Q84 45 78 38 Q76 44 78 52 Z" fill="#FFFFFF" fill-opacity="0.5" />
    <path d="M85 63 Q86 53 80 46 Q78 52 80 60 Z" fill="#FFFFFF" fill-opacity="0.5" />
    <polygon points="60,30 68,46 86,48 73,61 77,79 60,70 43,79 47,61 34,48 52,46" fill="#FFFFFF" filter="url(#jwShadow2)" />
    <polygon points="60,35 65,47 78,49 68,59 71,72 60,65 49,72 52,59 42,49 55,47" fill="url(#jwSilverGrad)" />
  </svg>
  `;

  // 1. 智能渲染与物理插队逻辑
  const injectTopMedals = () => {
    const jmHeader = document.querySelector('.jm-review-widget__header');
    if (!jmHeader) return;

    if (document.querySelector('.jw-injected-medals-container')) return;

    const medalsWrapper = document.createElement('div');
    medalsWrapper.className = 'jw-injected-medals-container';
    medalsWrapper.innerHTML = `
      <div class="jw-medal-item">${JW_MEDAL_1}</div>
      <div class="jw-medal-item">${JW_MEDAL_2}</div>
    `;
    
    if (window.innerWidth > 768) {
      // 💻 电脑端：塞在整个大 header 的最尾部，方便后面用 absolute 定位死死居中
      jmHeader.appendChild(medalsWrapper);
    } else {
      // 📱 手机端：找到核心包裹层 .jm-cluster，和 WRITE A REVIEW 所在的过滤器容器
      const clusterInner = jmHeader.querySelector('.jm-cluster');
      const filterContainer = jmHeader.querySelector('.jm-review-widget-minimal-header__filter-container');
      
      if (clusterInner && filterContainer) {
        // 挪到最下：直接把勋章作为最后一名追加进去，它自然就掉到了写评论和过滤器的下方
        clusterInner.appendChild(medalsWrapper);
      } else {
        jmHeader.appendChild(medalsWrapper);
      }
    }
  };

  const applyUserBadges = () => {
    const reviews = document.querySelectorAll(".jm-review-item, .jdgm-rev, .jdgm-divider-top");
    reviews.forEach(review => {
      const nameBlock = review.querySelector(".jm-reviewer-info__name") || 
                        review.querySelector(".jdgm-rev__author") || 
                        review.querySelector(".jdgm-rev__buyer-name");

      if (!nameBlock) return;
      if (nameBlock.querySelector(".jw-custom-badge")) return;

      const judgeVerified = review.querySelector(".jdgm-rev__buyer-badge.jdgm--verified") || 
                            review.querySelector(".jm-reviewer-badge--verified") || 
                            review.querySelector(".jdgm-rev__buyer-badge");

      const badge = document.createElement("span");
      if (judgeVerified) {
        judgeVerified.remove();
        badge.className = "jw-custom-badge jw-status-verified";
        badge.textContent = "Verified";
      } else {
        badge.className = "jw-status-reviewer";
        badge.textContent = "Reviewer";
      }
      nameBlock.appendChild(badge);
    });
  };

  const runAllCustomLogic = () => {
    if (isModifying) return;
    isModifying = true;
    injectTopMedals();
    applyUserBadges();
    isModifying = false;
  };

  const checkInterval = setInterval(() => {
    if (document.querySelector('.jm-review-widget, .jdgm-widget, .jdgm-rev-widget')) {
      runAllCustomLogic();
    }
  }, 400);

  setTimeout(() => clearInterval(checkInterval), 12000);

  const observer = new MutationObserver(() => {
    if (!isModifying) runAllCustomLogic();
  });
  observer.observe(document.body, { childList: true, subtree: true });

  if (document.readyState !== "loading") runAllCustomLogic();
  else document.addEventListener("DOMContentLoaded", runAllCustomLogic);

  /***************************************************************
   * 🚀 ⭐ 尾部逻辑：根据屏幕宽度进行样式纠偏与显示判定
   ***************************************************************/
  const enforceLayoutCenter = () => {
    const container = document.querySelector('.jw-injected-medals-container');
    if (!container) return;

    // 🌟 1. 查数：页面上有任何一条真实的评论卡片吗？
    const hasRealReviews = document.querySelectorAll('.jdgm-rev:not(.jdgm-rev-dummy), .jm-review-item').length > 0;

    // 🚫 2. 没评论（或全空），强制蒸发隐藏
    if (!hasRealReviews) {
      container.style.setProperty('display', 'none', 'important');
      return;
    }

    // 💻 3. 定位微调
    const header = document.querySelector('.jm-review-widget__header');
    if (header) {
      if (window.innerWidth > 768) {
        // 电脑端：死死卡在头部正中央
        header.style.position = 'relative';
        container.style.setProperty('display', 'flex', 'important');
        container.style.position = 'absolute';
        container.style.left = '50%';
        container.style.top = '50%';
        container.style.transform = 'translate(-50%, -50%)';
        container.style.margin = '0';
      } else {
        // 手机端：清除绝对定位，让其在 .jm-cluster 内部自动居中并独占一行
        container.style.setProperty('display', 'flex', 'important');
        container.style.position = 'static';
        container.style.transform = 'none';
        container.style.setProperty('width', '100%', 'important');
        container.style.setProperty('justify-content', 'center', 'important');
      }
    }
  };
  
  setInterval(enforceLayoutCenter, 300);

})();